<template>
  <div class="bx--grid">
    <div class="bx--row">
      <div class="bx--col-lg-12 masthead">
        <img style="margin-bottom: 3rem" src="@/assets/wirfuerschule_logo_white.png" />
        <h1>Lernen, Inspiration & Motivation</h1>
        <h3 style="margin-top: 10px">durch...</h3>
      </div>
    </div>
    <div class="bx--row">
      <div class="bx--col-sm-12 bx--col-md-4 bx--col-lg-3 panel">
        <img class="icon--image" src="@/assets/path.png" />
        <h2>Freiheit</h2>
      </div>
      <div class="bx--col-sm-12 bx--col-md-4 bx--col-lg-3 panel">
        <img class="icon--image" src="@/assets/map.png" />
        <h2>Orientierung</h2>
      </div>
      <div class="bx--col-sm-12 bx--col-md-4 bx--col-lg-3 panel">
        <img class="icon--image" src="@/assets/game-boy-advance.png" />
        <h2>Spiel & Wettkampf</h2>
      </div>
      <div class="bx--col-sm-12 bx--col-md-4 bx--col-lg-3 panel">
        <img class="icon--image" src="@/assets/gift.png" />
        <h2>Belohnung</h2>
      </div>
    </div>
    <div class="bx--row descriptions">
      <div class="bx--col-sm-12 bx--col-md-12 bx--col-lg-5 bx--offset-lg-1 box">
        <article>
          <h1>Für Schüler*innen</h1>
          <p>Individuelles Lernen unabhängig vom Präsenzunterricht</p>
          <p>Orientierung durch Themenpfade und Fortschrittsgrade</p>
          <p>Selbstbestimmung der Reihenfolge der Abarbeitung von Aufgaben und Themenbereiche</p>
          <p>Selbstbestimmung von Intensität pro Themenbereich</p>
          <p>Wettkampf im Team möglich</p>
          <p>Erfolgserlebnisse durch Belohnungssystem</p>
        </article>
      </div>
      <div class="bx--col-sm-12 bx--col-md-12 bx--col-lg-5 box">
        <article>
          <h1>Für Lehrer*innen</h1>
          <p>Entwicklung differenzierter Lernpfade unterschiedlicher Niveaustufen</p>
          <p>Kombination aus Wissen, Methoden & Sozialkompetenzen auch fächerübergreifend</p>
          <p>Transparenz des Fortschritts der Aufgaben aller Schüler</p>
          <p>Konfigurierbare Teams aus Schülern</p>
          <p>Wettkampfmodus - mit Belohnungssystem</p>
        </article>
      </div>
    </div>

    <div class="bx--row">
      <a class="bx--col-sm-12 bx--col-md-4 bx--col-lg-1 panel bx--offset-lg-3 panel--icon" href="https://github.com/KaiWedekind/wirfuerschule" target="_blank">
        <font-awesome-icon :icon="['fab', 'github']" class="icon3"/>
        <span class="iconText">on GitHub</span>
      </a>
      <a class="bx--col-sm-12 bx--col-md-4 bx--col-lg-1 panel panel--icon" href="https://www.youtube.com/watch?v=Gz8XKxcWdQ4" target="_blank">
        <font-awesome-icon :icon="['fab', 'youtube']" class="icon3"/>
        <span class="iconText">on YouTube</span>
      </a>
      <div class="bx--col-sm-12 bx--col-md-12 bx--col-lg-2 footer">
        <img src="@/assets/icon_whiteArtboard 1.png" />
      </div>
      <a class="bx--col-sm-12 bx--col-md-4 bx--col-lg-1 panel panel--icon" href="https://devpost.com/software/skillrocket-21avcl" target="_blank">
        <img src="@/assets/devpost_icon.png" class="icon2" />
        <span class="iconText">on DevPost</span>
      </a>
      <a class="bx--col-sm-12 bx--col-md-4 bx--col-lg-1 panel panel--icon" href="https://www.dropbox.com/sh/f5vj4k5fp1lh6hj/AADEbGPb7nhGlXHsS9kCvr1Va?dl=0" target="_blank">
        <font-awesome-icon :icon="['fab', 'dropbox']" class="icon3"/>
        <span class="iconText">on DropBox</span>
      </a>
    </div>

    <div class="bx--row">
      <div class="bx--col-sm-12 bx--col-md-12 bx--col-lg-12 footer2">
        <span>mit <span style="color:red">❤</span> gemacht von team fanta9</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Intro"
};
</script>

<style>

.masthead {
  margin-top: -3rem;
  text-align: center;
}

.masthead h1 {
  font-size: calc(32px + (60 - 32) * (100vw - 320px) / (1440 - 320)) !important;
}

.masthead img {
  height: 3rem;
  margin-top: 2rem;
}

.footer {
  margin-top: 1rem;
}

.footer img {
  width: 10rem;
  display: block;
  margin: auto;
}

.panel {
  text-align: center;
}

.panel h2 {
  font-size: calc(14px + (26 - 14) * (100vw - 320px) / (1440 - 320));
}

.icon--image {
  max-height: 5rem;
  margin-bottom: 1rem;
  margin-top: 3rem;
}

.descriptions {
  margin-top: 4rem;
}

.box {
  padding: 1rem;
  background-color: rgba(72, 80, 90, 0.5);
  margin-right: 1rem;
  margin-bottom: 1rem;
}

.box article {
  padding: 1rem;
}

.wirfuerschule {
  width: 300px;
}

.icon2 {
  margin-top: 1.25rem;
  width: 2.5rem;
}

.icon3 {
  margin-top: 1.25rem;
  font-size: 2.5rem;
}

.footer2 {
  margin-top: 1rem;
  text-align: center;
}

.iconText {
  display: block;
  margin-top: 0.5rem;
}

.panel--icon {
  color: white;
  text-decoration: none;
}

</style>
